import { render } from "./DetallePrograma.vue?vue&type=template&id=244dfe49"
import script from "./DetallePrograma.vue?vue&type=script&lang=js"
export * from "./DetallePrograma.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__